import React from 'react'
import MyMedineUploadSuccess from '../Components/MyMedicineUploadSuccess/MyMedineUploadSuccess'

const MyMedicineUploadSuccessView = () => {
  return (
    <div>
      <MyMedineUploadSuccess />
    </div>
  )
}

export default MyMedicineUploadSuccessView